// Sentry must initialize before any other module so its instrumentation
// (browser tracing, replays, unhandled-rejection capture) is in place when
// app code starts running. Per the @sentry/react SKILL.md guide.
import './instrument';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux'
import { store } from './store'
import AppErrorBoundary from './components/ErrorPage/AppErrorBoundary'
// Bootstrap (CSS + JS bundle) was removed — the app styles with Tailwind + MUI,
// and the handful of remaining Bootstrap classes (navbar, btn, toast, etc.)
// were converted to Tailwind. Tailwind layers first (compiled by CRACO/PostCSS),
// then app custom SCSS.
import './tailwind.css'
import './index.scss'
// Phase B: Firebase init removed; backend is self-hosted NestJS.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </Provider>
);

// Register the service worker so the app is a fully installable PWA — this is
// what lets Chrome on Android mint a proper WebAPK (current targetSdk) instead
// of a legacy shortcut that triggers Play Protect's "older Android" warning.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}
